import { useState } from "react";
import { BlocksRenderer, type BlocksContent } from "@strapi/blocks-react-renderer";
import { FAQ } from "@/types/faqs";

import { TabsContent } from "@/components/ui/tabs";

import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

import {
	ChevronUp,
	ChevronDown
} from "lucide-react";

interface FaqProps {
	faqs: FAQ[];
	tabContentValue: string;
}
export default function Faq({ faqs, tabContentValue }: FaqProps) {
	const [expandedFAQs, setExpandedFAQs] = useState<{ [key: string]: boolean }>(
		{},
	);

	// FAQ functions
	const toggleFAQ = (faqId: string) => {
		setExpandedFAQs((prev) => ({
			...prev,
			[faqId]: !prev[faqId],
		}));
	};

	return (
		<TabsContent value={tabContentValue}>
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
				{faqs.map((faq, index) => (
					<motion.div
						key={faq.id}
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: index * 0.1 }}
						viewport={{ once: true }}
					>
						<Card className="bg-newTheme-lightBlue glass-card border-0 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer">
							<CardContent className="p-6">
								<button
									onClick={() => toggleFAQ(faq.id)}
									className="w-full text-left"
								>
									<div className="flex items-start justify-between">
										<h3 className="text-xl lg:text-[24px] font-normal text-black font-karla pr-4 leading-tight lgleading-relaxed">
											{faq.question}
										</h3>
										<div className="flex-shrink-0 mt-1">
											{expandedFAQs[faq.id] ? (
												<ChevronUp className="w-5 h-5 text-black" />
											) : (
												<ChevronDown className="w-5 h-5 text-black" />
											)}
										</div>
									</div>
								</button>

								{expandedFAQs[faq.id] && (
									<motion.div
										initial={{ opacity: 0, height: 0 }}
										animate={{ opacity: 1, height: "auto" }}
										exit={{ opacity: 0, height: 0 }}
										transition={{ duration: 0.3 }}
										className="mt-4 pt-4 border-t border-primary-100"
									>
										{faq.answer && (
											<BlocksRenderer
												content={faq.answer as BlocksContent}
											/>
										)}
										{faq.topic && (
											<div className="mt-3">
												<Badge
													variant="secondary"
													className="bg-newTheme-lime text-black"
												>
													{faq.topic}
												</Badge>
											</div>
										)}
									</motion.div>
								)}
							</CardContent>
						</Card>
					</motion.div>
				))}
			</div>
		</TabsContent>
	)
}